<template>
  <div class="contact-us">
    <!-- Banner 图片 -->
    <div v-if="data.bannerImage" class="banner-section">
      <img :src="data.bannerImage" alt="Banner" class="banner-image">
    </div>
    <div class="contact-us-header">
      <img src="@/assets/images/la1.png" alt="联系我们背景" class="contact-us-bg">
      <div class="contact-us-title">联系我们</div>
    </div>
    <!-- 联系信息列表 -->
    <div v-if="data.contactList && data.contactList.length > 0" class="contact-section">
      <div class="contact-container">
        <div v-for="(item, index) in data.contactList" :key="index" class="contact-item">
          <div class="contact-icon">
            <img v-if="item.icon === 'address'" slot="" src="@/assets/images/la41.png" class="el-icon-location" />
            <img v-else-if="item.icon === 'phone'" slot="" src="@/assets/images/la42.png" class="el-icon-location" />
            <i v-else-if="item.icon === 'email'" class="el-icon-message"></i>
            <i v-else class="el-icon-info"></i>
          </div>
          <div class="contact-content">
            <div class="contact-label">{{ item.label }}</div>
            <div class="contact-text">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  props: {
    data: {
      type: Object,
      default: () => ({
        bannerImage: '',
        contactList: []
      })
    }
  }
}
</script>

<style scoped>
.contact-us {
  width: 100%;
}

/* Banner 区域 */
.banner-section {
  width: 100%;
  height: 400px;
  margin-bottom: 0;
}

.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 联系我们标题区域 */
.contact-us-header {
  width: 100%;
  padding: 60px 20px 40px;
  background: #fff;
  text-align: center;
  position: relative;
}

.contact-us-bg {
  width: 80px;
  height: auto;
  margin: 0 auto 20px;
  display: block;
}

.contact-us-title {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

/* 联系信息区域 */
.contact-section {
  width: 100%;
  background: #fff;
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 60px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  flex-wrap: wrap;
}

.contact-item {
  flex: 0 1 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px;
  transition: all 0.3s;
}

.contact-item:hover {
  transform: translateY(-4px);
}

.contact-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 48px;
  margin-bottom: 20px;
}

.contact-icon i {
  font-weight: normal;
}

.contact-content {
  width: 100%;
}

.contact-label {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.contact-text {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  word-break: break-word;
}

/* 移动端 */
@media (max-width: 768px) {
  .banner-section {
    height: 250px;
  }

  .contact-us-header {
    padding: 40px 16px 32px;
  }

  .contact-us-bg {
    width: 60px;
    margin-bottom: 16px;
  }

  .contact-us-title {
    font-size: 28px;
  }

  .contact-section {
    padding: 40px 0;
  }

  .contact-container {
    padding: 40px 16px;
    flex-direction: column;
    gap: 32px;
  }

  .contact-item {
    flex: 1;
    width: 100%;
    max-width: 400px;
    padding: 24px 20px;
  }

  .contact-icon {
    width: 56px;
    height: 56px;
    font-size: 40px;
    margin-bottom: 16px;
  }

  .contact-label {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .contact-text {
    font-size: 15px;
  }
}
</style>
